export default __webpack_public_path__ + "static/media/car.65018e99.svg";